const hotjarTrigger = (name) => {
  const isHotjarAvailable = !!(
    typeof window !== 'undefined' && window.hj
  )

  if (isHotjarAvailable) {
    // eslint-disable-next-line no-console
    console.log(`hotjar for [${name}] triggered`)
    window.hj('trigger', name)
  } else {
    // eslint-disable-next-line no-console
    console.log('hotjar is not avaiable')
  }
}

export default hotjarTrigger
